import React from 'react'
import style from './marketingform.module.scss'
import { VegaInput } from '../../vega/input/Input'
import { VegaButton, VegaButtonTypes } from '../../vega/button/Button'
import { VegaHeading } from '../../vega/heading/Heading'
import { VegaCheckbox } from '../../vega/checkbox/Checkbox'
import { useDispatch, useSelector } from 'react-redux'
import {
	setUserAskInfos,
	postMarketingInfos
} from '../../../redux/modules/user/userAction'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
import yup from '../../../utils/translation/yup'
import { PropTypes } from 'prop-types'

/**
 * Marketing form to collect user datas, it is a smart component using Redux
 */
const MarketingForm = () => {
	const dispatch = useDispatch()
	const onFormSubmit = () => {
		dispatch(setUserAskInfos(false))
	}
	const onFormValidated = (formData) => {
		dispatch(postMarketingInfos(formData))
	}

	const currentMail = useSelector((state) => state.UserReducer.mail)
	return (
		<PureMarketingForm
			currentMail={currentMail}
			onFormSubmit={onFormSubmit}
			onFormValidated={onFormValidated}
		/>
	)
}

export const formSchema = yup.object().shape({
	mail: yup.string().email().required('shareEmailEmpty'),
	accept: yup.boolean()
})

export const PureMarketingForm = ({ currentMail, onFormSubmit, onFormValidated }) => {
	const { t } = useTranslation()
	const { register, triggerValidation, errors, getValues } = useForm({
		validationSchema: formSchema
	})

	const onSubmit = async () => {
		onFormSubmit()
		let formData = getValues()
		const result = await triggerValidation()
		if (result) {
			onFormValidated(formData)
		}
	}

	return (
		<>
			<VegaInput
				ref={register}
				name="mail"
				value={currentMail}
				placeholder={t('mktEmailAddressPlaceholder')}
				className={style.input}
				label={t('mktEmailAddress')}
				errorMessage={t(errors?.mail?.message)}
				onBlur={async () => {
					triggerValidation('mail')
				}}
			/>

			<VegaCheckbox
				ref={register}
				name="accept"
				label={t('mktUserOptIn')}
				className={style.checkbox}
			/>
			<VegaHeading
				tag="h7"
				className={style.checkboxSubtitle}
				label={t('mktUserOptInSubtitle')}
			/>
			<VegaButton
				data-testid="submit"
				type={VegaButtonTypes.PRIMARY}
				label={t('mktValidateButton')}
				className={style.button}
				onClick={onSubmit}
			/>
		</>
	)
}

PureMarketingForm.propTypes = {
	/** Mail set in the form at load */
	currentMail: PropTypes.string,
	/** Action triggered when the form is submitted */
	onFormSubmit: PropTypes.func,
	/** Action that contains the form values */
	onFormValidated: PropTypes.func
}

export { MarketingForm }
